var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.$route.params.type != 1 ? _c("a-steps", {
    style: _vm.stepStyle,
    attrs: {
      type: "navigation"
    },
    model: {
      value: _vm.current,
      callback: function ($$v) {
        _vm.current = $$v;
      },
      expression: "current"
    }
  }, [_c("a-step", {
    attrs: {
      status: _vm.current == 0 ? "process" : "finish",
      title: _vm.$t("基本信息"),
      disabled: ""
    }
  }), _c("a-step", {
    attrs: {
      status: "process",
      title: _vm.$t("证件资料"),
      disabled: ""
    }
  })], 1) : _vm._e(), _vm.current == 0 ? _c("information", {
    attrs: {
      infoObj: _vm.infoObj,
      type: _vm.$route.params.type,
      id: _vm.id
    },
    on: {
      next: _vm.nextFun
    }
  }) : _vm._e(), _vm.current == 1 ? _c("certificate", {
    attrs: {
      type: _vm.$route.params.type,
      id: _vm.id,
      infoObj: _vm.infoObj
    },
    on: {
      prev: _vm.prevFun,
      back: function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }) : _vm._e(), _vm.current == 0 && _vm.$route.params.type == 1 ? _c("certificate", {
    attrs: {
      type: _vm.$route.params.type,
      id: _vm.id,
      infoObj: _vm.infoObj
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };